// Imports
import {
	State,
	STORE_WEBSITE,
	Actions,
	STORE_PAGES,
	STORE_HOMEPAGE_VISIBILITY,
	STORE_MEMBER,
	SET_MEMBER_LOADED,
	SET_ADMIN_VIEW,
	SET_GLOBAL_SIGN_IN,
	SET_GLOBAL_SIGN_IN_LOADED,
	SET_PHONE,
} from './types';


// Define initial state
const initialState: State = {
	website: null,
	pages: null,
	pageTypeID: null,
	homepageVisibility: null,
	member: null,
	memberLoaded: false,
	adminView: true,
	globalSignIn: false,
	globalSignInLoaded: false,
	phone: null,
};


// The root reducer
export default function reducer(state = initialState, action: Actions): State {
	switch (action.type) {
		case STORE_WEBSITE:
			return {
				...state,
				website: action.website,
			};
		case STORE_PAGES:
			return {
				...state,
				pages: action.pages,
			};
		case STORE_HOMEPAGE_VISIBILITY:
			return {
				...state,
				homepageVisibility: action.homepageVisibility,
			};
		case STORE_MEMBER:
			return {
				...state,
				member: action.member,
			};
		case SET_MEMBER_LOADED:
			return {
				...state,
				memberLoaded: true,
			};
		case SET_ADMIN_VIEW:
			return {
				...state,
				adminView: action.adminView,
			};
		case SET_GLOBAL_SIGN_IN:
			return {
				...state,
				globalSignIn: action.globalSignIn,
			};
		case SET_GLOBAL_SIGN_IN_LOADED:
			return {
				...state,
				globalSignInLoaded: true,
			};
		case SET_PHONE:
			return {
				...state,
				phone: action.phone,
			};
		default:
			return state;
	}
}
